import { fetchApi } from 'Utils/utils';

let getReport = function(fromDate, toDate) {
  return fetchApi.get(`/api/v1/backOrderProductVariant/getReport/${fromDate}/${toDate}/`);
};

export { getReport };
